export default __webpack_public_path__ + "static/media/call.0baf20e6.svg";